import React from 'react';
import Logo from '../../assets/logo.png';

const NotAuthorized: React.FC = () => {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center">
      <img src={Logo} alt="Logo" className="w-1/4 object-cover" />
      <span className="mt-8 text-darkText text-4xl font-regular text-center ">
        You are not authorized to access this page.
      </span>
    </div>
  );
};

export default NotAuthorized;
